import { Button } from "@vds/buttons";
import { Checkbox } from "@vds/checkboxes";
import { Input } from "@vds/inputs";
import {
  ListGroup
} from "@vds/lists";
import { Modal } from "@vds/modals";
import { Notification } from "@vds/notifications";
import { DropdownSelect } from "@vds/selects";
import { Body, Title } from "@vds/typography";
import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { connect, useDispatch, useSelector } from "react-redux";
import SearchInput, { getDisplayPhoneNumber, isInvalidContactNumber, validateEmail } from "../../global/utility/Utils";
import { INVITE_USER_ERROR_MESSAGES, INVITE_USER_SUCCESS_MESSAGES, INVITE_USER_MODAL_CONSTANTS, USER_GROUP_DETAILS_CONSTANTS, USER_ROLE, NON_NUMERIC_REGEX, NAME_VALIDATION_PATTERN, CONSECUTIVE_SPACES_REGEX } from "../../global/constants/constants";
import { NOTIFICATION_PRIORITY_SUCCESS, NOTIFICATION_PRIORITY_CRITICAL, NOTIFICATION_TYPE_INVITE_SENT } from "../../global/constants/userDetailsConstants";
import { STORAGE } from "../../global/constants/storageConstants";
import { getUserSitesData } from "../../model/reportService";
import { getUserSites } from "../../model/roleService";
import {
  assignRole,
  fetchBillingAccounts,
  setEmail,
  setFirstName,
  setLastName,
  setPhoneNumber,
  showNotificationBanner,
  updateCheckedSites,
  updateSelectedGroups,
} from "../../store/actions";
import { processSitesTags } from "../../store/sagas/sites-saga";
import { fetchSitesForBillingAccount } from "../Sites/SiteService";
import { inviteUser } from "./userGroupsService";
import {
  ModalInputContainer,
  ModalInputContainerFirst,
  ModalDropdownContainer,
  ModalNotificationContainer,
  ModalButtonGroup,
  ModalButtonGroupWithMargin,
  ModalButtonGroupWithTopMargin,
  ModalButtonGroupWithGap,
  BillingAccountsListWrapper,
  BillingAccountRow,
  BillingAccountCheckboxWrapper,
  AssignSiteStickyHeader,
  AssignSiteStickyFooter,
  AssignSiteIntroWrapper,
  SiteSearchWrapper,
  SitesScrollWrapper,
  SiteRow,
  SiteRowLabelWrapper,
  SiteRowName,
} from "./styles";
import "./UserGroupsModals.css";
// import { NoWidthCheckbox } from "./styles";

const InviteUserModal = ({
  title,
  showModal = false,
  setShowModal,
  setFirstName,
  setLastName,
  setPhoneNumber,
  setEmail,
  setShowNotificationPopup,
  usersList,
  setShowNotification,
  bannerType,
  setBannerType,
  onInviteSuccess,
  usersSiteList
}) => {
  const { activeSession } = useSelector(
    (state) => state.sessionReducer.activeSession
  );
  const rolesList = useSelector((state) => state.userRoleReducer.roleList);
  const sitesTagList = useSelector((state) => state.sitesReducer.siteTagList);
  const selectedRole = JSON.parse(sessionStorage.getItem(STORAGE.SELECTED_ROLE));
  const [step, setStep] = useState(1);
  const [searchValue, setSearchValue] = useState("");
  const [siteList, setSiteList] = useState([]);
  const [selectedSites, setSelectedSites] = useState([]);
  const [selectedBillingAccounts, setSelectedBillingAccounts] = useState([]);
  const [selectedSiteIndex, setSelectedSiteIndex] = useState(0);
  const [isValid, setIsValid] = useState(false);
  const [selectedTab, setSelectedTab] = useState("User info");
  const [allSitesChecked, setAllSitesChecked] = useState(false);
  const [skipStepChecked, setSkipStepChecked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [sitesFetchLoading, setSitesFetchLoading] = useState(false);
  const [invalidEmail, setinvalidEmail] = useState(false);
  const [invalidPhoneNum, setInvalidPhoneNum] = useState(true);
  const [invalidFirstName, setInvalidFirstName] = useState(false);
  const [invalidLastName, setInvalidLastName] = useState(false);
  const [adminId, setAdminId] = useState(null);
  const [phoneTouched, setPhoneTouched] = useState(false);
  const { setValue, watch, reset } = useForm();
  const prevShowModal = useRef(false);
  const [noSiteForBAIDMessage, setNoSiteForBAIDMessage] = useState("");
  const isModalOpen = showModal === true || !!showModal?.isOpen;

  // canonical helpers (always return string key or null)
  const getSiteKey = (s) => {
    const raw = s?.siteTagId || s?.siteid || s?.id;
    return raw === undefined || raw === null ? null : String(raw);
  };
  const getSiteTitle = (s) =>
    s?.siteTagName || s?.name || s?.title || s?.sitename || "";

  const handlePhoneNumChange = (e) => {
    const input = e.target;
    const cursorPos = input.selectionStart;
    const oldValue = input.value;
    
    setPhoneTouched(true);
    let newPhoneNum = oldValue.replace(NON_NUMERIC_REGEX, "");
    if (newPhoneNum.length > 10) {
      newPhoneNum = newPhoneNum.slice(0, 10);
    }

    const formattedNum = getFormatedContactNumber(newPhoneNum);
    const isValid =
      !isInvalidContactNumber(formattedNum) &&
      newPhoneNum.length === 10 &&
      (newPhoneNum?.length !== 0 ||
        newPhoneNum?.length !== undefined ||
        newPhoneNum?.length !== null);

    setInvalidPhoneNum(!isValid);
    if (newPhoneNum.length <= 10) {
      dispatch(setPhoneNumber(formattedNum));
    }

    setTimeout(() => {
      if (!input) return;
      let newPos = cursorPos;
      const oldDashes = (oldValue.slice(0, cursorPos).match(/-/g) || []).length;
      const newDashes = (formattedNum.slice(0, cursorPos).match(/-/g) || []).length;
      newPos += newDashes - oldDashes;
      if (formattedNum[newPos] === "-") newPos++;
      input.setSelectionRange(newPos, newPos);
    }, 0);
  };
  const [errors, setErrors] = useState({
    email: INVITE_USER_ERROR_MESSAGES.email,
    firstName: INVITE_USER_ERROR_MESSAGES.firstName,
    lastName: INVITE_USER_ERROR_MESSAGES.lastName,
    phoneNumber: INVITE_USER_ERROR_MESSAGES.phoneNumber,
  });

  const handleEmailChange = (e) => {
    const newEmail = e.target.value;
    setinvalidEmail(!validateEmail(newEmail));

    // Check if the email already exists
    const existingEmails = (usersList || [])
      .map((user) => user?.email || user?.Email || user?.inviteeemail)
      .filter((item) => item !== undefined);

    if (existingEmails.includes(newEmail)) {
      setinvalidEmail(true);
      const isPendingInvite = (usersList || []).some(user => 
        user?.inviteeemail === newEmail
      );
      setErrors({ 
        email: isPendingInvite 
          ? INVITE_USER_ERROR_MESSAGES.emailAlreadyInvited 
          : INVITE_USER_ERROR_MESSAGES.emailAlreadyExists 
      });
    }

    // Check for an invalid email like ". @gmail.com"
    if (newEmail.match(/^(\.|\s|@)/)) {
      setinvalidEmail(true);
      setErrors({ email: INVITE_USER_ERROR_MESSAGES.emailInvalidFormat });
    }

    setEmail(newEmail);
  };
  const getFormatedContactNumber = (num) => {
    const digits = num.replace(/\D/g, "").slice(0, 10); // Only first 10 digits
    const part1 = digits.slice(0, 3);
    const part2 = digits.slice(3, 6);
    const part3 = digits.slice(6, 10);

    if (digits.length > 6) {
      return `${part1}-${part2}-${part3}`;
    } else if (digits.length > 3) {
      return `${part1}-${part2}`;
    } else {
      return part1;
    }
  };

  const validateName = (name, fieldName) => {
    const trimmedName = name.trim();
    
    // Check if empty
    if (trimmedName === "") {
      return {
        isValid: false,
        errorMessage: fieldName === "firstName" 
          ? INVITE_USER_ERROR_MESSAGES.firstName 
          : INVITE_USER_ERROR_MESSAGES.lastName
      };
    }
    
    if (!NAME_VALIDATION_PATTERN.test(trimmedName)) {
      return {
        isValid: false,
        errorMessage: fieldName === "firstName" 
          ? INVITE_USER_ERROR_MESSAGES.firstNameInvalid 
          : INVITE_USER_ERROR_MESSAGES.lastNameInvalid
      };
    }
    
    return { isValid: true, errorMessage: "" };
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    if (name === "firstName") {
      const normalized = value.replace(CONSECUTIVE_SPACES_REGEX, ' ');
      dispatch(setFirstName(normalized));
      const validation = validateName(normalized, "firstName");
      setInvalidFirstName(!validation.isValid);
      if (!validation.isValid) {
        setErrors(prev => ({ ...prev, firstName: validation.errorMessage }));
      } else {
        setErrors(prev => ({ ...prev, firstName: "" }));
      }
    } else if (name === "lastName") {
      const normalized = value.replace(CONSECUTIVE_SPACES_REGEX, ' ');
      dispatch(setLastName(normalized));
      const validation = validateName(normalized, "lastName");
      setInvalidLastName(!validation.isValid);
      if (!validation.isValid) {
        setErrors(prev => ({ ...prev, lastName: validation.errorMessage }));
      } else {
        setErrors(prev => ({ ...prev, lastName: "" }));
      }
    }
  };

  const handleNameBlur = (event) => {
    const { name, value } = event.target;
    const trimmed = value.trim();
    if (name === "firstName" && trimmed !== value) {
      dispatch(setFirstName(trimmed));
      const validation = validateName(trimmed, "firstName");
      setInvalidFirstName(!validation.isValid);
      setErrors(prev => ({ ...prev, firstName: validation.isValid ? "" : validation.errorMessage }));
    } else if (name === "lastName" && trimmed !== value) {
      dispatch(setLastName(trimmed));
      const validation = validateName(trimmed, "lastName");
      setInvalidLastName(!validation.isValid);
      setErrors(prev => ({ ...prev, lastName: validation.isValid ? "" : validation.errorMessage }));
    }
  };

  const dispatch = useDispatch();

  const {
    firstName,
    lastName,
    phoneNumber,
    email,
    assignedRole,
    checkedSites,
    selectedGroups,
  } = useSelector((state) => state.inviteUserReducer);

  const billingAccounts = useSelector(
    (state) => state.inviteUserModalReducer.billingAccounts
  );

  //Sending admin roleId for siteless account on user invite
  const findAdminId = () => {
    const adminRole = rolesList?.find((role) => role.name === INVITE_USER_MODAL_CONSTANTS.OPTION_ADMIN);
    return adminRole ? adminRole.id : null;
  };

  // Clear Redux state on component mount to handle page refresh
  useEffect(() => {
    if(!isModalOpen) return;

    dispatch(setFirstName(""));
    dispatch(setLastName(""));
    dispatch(setPhoneNumber(""));
    dispatch(setEmail(""));
    dispatch(updateCheckedSites([]));
    dispatch(updateSelectedGroups({}));
  }, [isModalOpen]);

  useEffect(() => {
    const adminRoleId = findAdminId();
    setAdminId(adminRoleId);
  }, [rolesList]);

  const onSubmit = async () => {
    setLoading(true);
    const userData = {
      firstname: firstName,
      lastname: lastName,
      mdn: phoneNumber,
      email: email,
      role: assignedRole || adminId,
      tagids: checkedSites.map((site) => site.id),
      billingAccounts: selectedBillingAccounts,
    };

    try {
      const response = await inviteUser(
        userData,
        activeSession,
        setShowNotificationPopup,
        setShowModal
      );
      if (response?.wasemailsent) {
        const notificationInfo = {
          type: NOTIFICATION_TYPE_INVITE_SENT,
          priority: NOTIFICATION_PRIORITY_SUCCESS,
          data: {
            subTitle: INVITE_USER_SUCCESS_MESSAGES.inviteSent(
              userData.firstname + " " + userData.lastname
            ),
          },
          showNotification: true,
        };
        dispatch(showNotificationBanner(notificationInfo));
        dispatch(setFirstName(""));
        dispatch(setLastName(""));
        dispatch(setPhoneNumber(""));
        dispatch(setEmail(""));
        setSelectedSites([]);
        dispatch(updateCheckedSites([]));
        setAllSitesChecked(false);
        setShowModal(false);
        onInviteSuccess?.();
      } else {
        const notificationInfo = {
          type: INVITE_USER_MODAL_CONSTANTS.NOTIFICATION_TYPE_INVITE_FAILED,
          priority: NOTIFICATION_PRIORITY_CRITICAL,
          data: {
            subTitle: INVITE_USER_ERROR_MESSAGES.inviteFailedGeneric,
          },
          showNotification: true,
        };
        dispatch(showNotificationBanner(notificationInfo));
      }
    } catch (error) {
      const rawError =
        error?.errorResponse?.data?.validation_errors?.[0]?.message ||
        error?.errorResponse?.data?.message ||
        error?.errorResponse?.data?.error_description ||
        error?.message ||
        INVITE_USER_ERROR_MESSAGES.inviteFailedGeneric;
      const errorMessage = rawError.includes("Requested username")
        ? rawError.replace("Requested username", email)
        : rawError;
      dispatch(
        showNotificationBanner({
          type: INVITE_USER_MODAL_CONSTANTS.NOTIFICATION_TYPE_INVITE_FAILED,
          priority: NOTIFICATION_PRIORITY_CRITICAL,
          data: { subTitle: errorMessage },
          showNotification: true,
        })
      );
    } finally {
      setLoading(false);
    }
  };

  // Reducer function to filter and extract site titles and subtitles
  const siteReducer = (accumulator, currentState, stateName) => {
    if (currentState.kind === "ts.tag.state") {
      stateName = currentState.name;
      const traverse = (tags, subtitle) => {
        tags.forEach((tag) => {
          if (tag.kind === "ts.tag.site") {
            accumulator.push({
              id: tag.id,
              title: tag.name,
              subtitle: subtitle ? `${subtitle}, ${stateName}` : tag.name,
              checked: false,
            });
          } else if (tag.nestedtags && tag.nestedtags.length > 0) {
            traverse(
              tag.nestedtags,
              `${subtitle ? subtitle + ", " : ""}${tag.name}`
            );
          }
        });
      };

      traverse(currentState.nestedtags, "");
    }
    return accumulator;
  };

  const formValues = watch();

  const handleDropdownChange = (e) => {
    const { name, value } = e.target;
    setValue(name, value);
  };

  useEffect(() => {
    // Only fetch billing accounts when modal opens (not on component mount)
    if (isModalOpen && !prevShowModal.current) {
      dispatch(fetchBillingAccounts());
    }
    prevShowModal.current = isModalOpen;
  }, [isModalOpen, dispatch]);

  const siteWrapper = (siteList) => {
    let list = [];
    siteList?.sites?.forEach((tag) => {
      list.push({
        id: tag.id,
        title: tag.name,
        checked: false,
      });
    });
    return list;
  };

  useEffect(() => {
    const validateFields = () => {
      const isEmailValid = validateEmail(email);
      const firstNameValidation = validateName(firstName, "firstName");
      const lastNameValidation = validateName(lastName, "lastName");
      const areFieldsValid =
        firstNameValidation.isValid &&
        lastNameValidation.isValid &&
        !invalidPhoneNum &&
        !invalidEmail;
      setIsValid(isEmailValid && areFieldsValid);
    };
    validateFields();
  }, [firstName, lastName, phoneNumber, email, invalidEmail, invalidPhoneNum]);

  const fetchUserSites = async () => {
    try {
      const userGroupResponse = JSON.parse(
        sessionStorage.getItem(STORAGE.USER_GROUPS_RESPONSE)
      );
      const rolePermissionsList = JSON.parse(
        sessionStorage.getItem(STORAGE.ROLE_PERMISSIONS_LIST)
      );
      const currentUserEmail = activeSession?.userName;
      const user = userGroupResponse?.find(
        (user) => user?.email === currentUserEmail
      );
      const roleId = rolePermissionsList["id"];
      const payload = {
        accountname: activeSession.accountId,
        grant: {
          userid: user?.id,
          roleid: roleId,
        },
      };

     

     // setSiteList(sitesTagList?.sites);
    } catch (error) {
      console.log("error in fetching userSite", error);
    }
  };

  // Only fetch sites when modal actually opens (avoid overwriting on Back/Next)
  useEffect(() => {
    if (
      isModalOpen &&
      !prevShowModal.current &&
      activeSession &&
      activeSession.accountId
    ) {
      fetchUserSites();
    }
    prevShowModal.current = isModalOpen;
  }, [isModalOpen, activeSession]);

  useEffect(() => {
    if (isModalOpen) {
      localStorage.removeItem(STORAGE.SKIP_TO_STEP_4);
      setStep(1);
    }
  }, [isModalOpen]);

  const handleSearchChange = (e) => {
    setSearchValue(e.target.value);
  };

  const handleCloseModal = () => {
    dispatch(setFirstName(""));
    dispatch(setLastName(""));
    dispatch(setPhoneNumber(""));
    dispatch(setEmail(""));
    dispatch(updateCheckedSites([]));
    dispatch(updateSelectedGroups({}));
    setSearchValue("");
    // Reset validation states
    setinvalidEmail(false);
    setInvalidPhoneNum(true);
    setInvalidFirstName(false);
    setInvalidLastName(false);
    setPhoneTouched(false);
    setErrors({
      email: INVITE_USER_ERROR_MESSAGES.email,
      firstName: INVITE_USER_ERROR_MESSAGES.firstName,
      lastName: INVITE_USER_ERROR_MESSAGES.lastName,
      phoneNumber: INVITE_USER_ERROR_MESSAGES.phoneNumber,
    });
    // clear local modal state
    setSelectedSites([]);
    setSelectedBillingAccounts([]);
    setSiteList([]);
    setAllSitesChecked(false);
    setIsValid(false);
    setStep(1);
    setSelectedSiteIndex(0);
    try {
      // clear any persisted helper keys used by modal
      sessionStorage.removeItem(STORAGE.INVITE_CHECKED_SITES);
      sessionStorage.removeItem(STORAGE.INVITE_MODAL_STEP);
      //sessionStorage.removeItem(STORAGE.SELECTED_ROLE);
    } catch (e) {}

    // reset react-hook-form values
    try {
      reset();
    } catch (e) {}

    // reset prev flag then close
    prevShowModal.current = false;
    setShowModal(false);
  };

  // only reset UI when modal actually opens (avoid wiping on back/next)
  useEffect(() => {
    if (isModalOpen && !prevShowModal.current) {
      const resetSiteList = (siteList || []).map((site) => ({
        ...site,
        checked: false,
      }));
      setSiteList(resetSiteList);
      setSelectedSites([]);
      setValue("role", "");
      setSelectedBillingAccounts([]);
    }
    prevShowModal.current = isModalOpen;
  }, [isModalOpen]);

  const roleName =
    rolesList?.find((item) => item.id === formValues?.role)?.name || null;

  const handleAllSitesToggle = () => {
    if (roleName === INVITE_USER_MODAL_CONSTANTS.OPTION_ADMIN) return;
    const newAllChecked = !allSitesChecked;
    setAllSitesChecked(newAllChecked);

    const updatedList = (siteList || []).map((site) => ({
      ...site,
      checked: newAllChecked,
    }));
    setSiteList(updatedList);

    const checkedSitesPayload = (updatedList || [])
      .filter((s) => s.checked && getSiteKey(s))
      .map((site) => ({
        id: getSiteKey(site),
        title: getSiteTitle(site),
        subtitle: site.subtitle || "",
      }));

    setSelectedSites(checkedSitesPayload.map((s) => s.title));
    dispatch(updateCheckedSites(checkedSitesPayload));
    setIsValid(
      roleName === INVITE_USER_MODAL_CONSTANTS.OPTION_ADMIN ||
        (roleName !== INVITE_USER_MODAL_CONSTANTS.OPTION_ADMIN && checkedSitesPayload.length > 0)
    );
  };

  const handleSiteToggle = (id) => {
    if (roleName === INVITE_USER_MODAL_CONSTANTS.OPTION_ADMIN) return;
    if (!id) {
      console.warn(
        "[InviteUserModal] handleSiteToggle called with falsy id, ignoring"
      );
      return;
    }
    const updatedList = (siteList || []).map((site) => {
      const key = getSiteKey(site);
      return key === id ? { ...site, checked: !site.checked } : site;
    });
    setSiteList(updatedList);
    setAllSitesChecked(updatedList.every((site) => site.checked));
    const checkedSitesPayload = (updatedList || [])
      .filter((s) => s.checked && getSiteKey(s))
      .map((site) => ({
        id: getSiteKey(site),
        title: getSiteTitle(site),
        subtitle: site.subtitle || "",
      }));
    setSelectedSites(checkedSitesPayload.map((s) => s.title));
    dispatch(updateCheckedSites(checkedSitesPayload));
    setIsValid(
      roleName === INVITE_USER_MODAL_CONSTANTS.OPTION_ADMIN ||
        (roleName !== INVITE_USER_MODAL_CONSTANTS.OPTION_ADMIN && checkedSitesPayload.length > 0)
    );
  };

  useEffect(() => {
    if (roleName !== INVITE_USER_MODAL_CONSTANTS.OPTION_ADMIN) return;
    if (!siteList || siteList.length === 0) return;

    const alreadyAllChecked = siteList.every((site) => site.checked);
    if (alreadyAllChecked && allSitesChecked) return;

    const updatedList = siteList.map((site) => ({ ...site, checked: true }));
    setSiteList(updatedList);
    setAllSitesChecked(true);

    const checkedSitesPayload = updatedList
      .filter((s) => getSiteKey(s))
      .map((site) => ({
        id: getSiteKey(site),
        title: getSiteTitle(site),
        subtitle: site.subtitle || "",
      }));
    setSelectedSites(checkedSitesPayload.map((s) => s.title));
    dispatch(updateCheckedSites(checkedSitesPayload));
    setIsValid(true);
  }, [roleName, siteList, allSitesChecked]);

  const handleNext = async () => {
    setLoading(true);
    let isValid = false;
    try {
      if (step === 1) {
        isValid = firstName && lastName && !invalidPhoneNum && !invalidEmail;
        setIsValid(isValid);
        if (isValid) {
          const userData = {
            firstName,
            lastName,
            phoneNumber,
            email,
          };
          dispatch(setFirstName(userData.firstName));
          dispatch(setLastName(userData.lastName));
          dispatch(setPhoneNumber(userData.phoneNumber));
          dispatch(setEmail(userData.email));
          if (localStorage.getItem(STORAGE.SKIP_TO_STEP_4) === "true") {
            setStep(3);
          } else {
            setStep(2);
          }
        } else {
          console.log("Please fill all fields.");
        }
      } else if (step === 2) {
        isValid = selectedBillingAccounts.length > 0;
        setIsValid(isValid);
        if (isValid) {
          //await getBillingAccountsBasedSites();
          setStep(3);
        }
      } else if (step === 3) {
        const role = formValues?.role;
        const roleName =
          rolesList.find((item) => item.id === formValues?.role)?.name || null;
        dispatch(assignRole(role));
        isValid =
          roleName === INVITE_USER_MODAL_CONSTANTS.OPTION_ADMIN ||
          (roleName !== INVITE_USER_MODAL_CONSTANTS.OPTION_ADMIN && siteList?.some((site) => site?.checked));

        setIsValid(isValid);
        if (role !== "") setStep(4);
      } else if (step === 4) {
        const roleName =
          rolesList.find((item) => item.id === formValues?.role)?.name || null;
        const checkedSitesData = (siteList || [])
          .filter((site) => site.checked && getSiteKey(site))
          .map((site) => ({
            id: getSiteKey(site),
            title: getSiteTitle(site),
            subtitle: site.subtitle || "",
          }));
        dispatch(updateCheckedSites(checkedSitesData));
        isValid = checkedSitesData.length > 0 || roleName === INVITE_USER_MODAL_CONSTANTS.OPTION_ADMIN;
        setIsValid(isValid);
      } else {
        handleCloseModal();
      }
    } catch (error) {
      console.error("Error while loading:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleBack = () => {
    if (step === 3 && selectedSiteIndex === 0) {
      if (localStorage.getItem(STORAGE.SKIP_TO_STEP_4) === "true") {
        setStep(4);
      } else {
        if (selectedBillingAccounts.length) {
          setIsValid(true);
        }
        setStep(2);
      }
    } else if (step === 3) {
      setSelectedSiteIndex((prevIndex) => prevIndex - 1);
    } else if (step === 4) {
      // const unCheckSitesOnBack = siteList.map((site) => ({
      //   ...site,
      //   checked: false,
      // }));
      // setAllSitesChecked(false);
      // setSiteList(unCheckSitesOnBack);
      setStep((prevStep) => prevStep - 1);
    } else if (step > 1) {
      setStep((prevStep) => prevStep - 1);
    } else {
      handleCloseModal();
    }
  };

  const getBillingAccountsBasedSites = async () => {
    try {
      const session = {
        accountId: selectedBillingAccounts[0],
        userId: activeSession.userId,
      };
      const result = await getUserSitesData(session);
      if (Array.isArray(result) && result.length > 0) {
        return result.length;
      } else {
         // setSiteList(sitesTagList?.sites);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleBillingAccountSelect = async (ba, nextChecked) => {
    setSelectedBillingAccounts(nextChecked ? [ba] : []);
    setNoSiteForBAIDMessage("");

    if (!nextChecked) {
      setSiteList([]);
      return;
    }

    setSitesFetchLoading(true);
    const sitesForAccount = await fetchSitesForBillingAccount(
      ba,
      activeSession.userId,
      selectedRole?.toLowerCase() === USER_ROLE.ADMIN
    );
    setSitesFetchLoading(false);

    if (sitesForAccount.length > 0) {
      setSiteList(sitesForAccount);
    } else {
      setSiteList([]);
      setNoSiteForBAIDMessage(INVITE_USER_MODAL_CONSTANTS.NO_SITE_FOR_BAID_MESSAGE);
    }
  };

  const renderStepContent = () => {
    let filteredSites = [];
    if (searchValue.trim() !== "") {
      const q = searchValue.toLowerCase();
      filteredSites = (siteList || []).filter((site) => {
        const title = (getSiteTitle(site) || "").toLowerCase();
        return title.includes(q);
      });
    } else {
      filteredSites = siteList;
    }
    switch (step) {
      case 1:
        return (
          <>
            <Title bold={true} size="medium">
              {INVITE_USER_MODAL_CONSTANTS.STEP_ONE_TITLE}
            </Title>
            <ModalInputContainerFirst>
              <Input
                type="text"
                label={INVITE_USER_MODAL_CONSTANTS.LABEL_FIRST_NAME}
                value={firstName}
                required={true}
                error={invalidFirstName}
                errorText={errors["firstName"] || INVITE_USER_ERROR_MESSAGES.firstName}
                name="firstName"
                onChange={handleInputChange}
                onBlur={handleNameBlur}
              />
            </ModalInputContainerFirst>
            <ModalInputContainer>
              <Input
                type="text"
                label={INVITE_USER_MODAL_CONSTANTS.LABEL_LAST_NAME}
                value={lastName}
                required={true}
                error={invalidLastName}
                errorText={errors["lastName"] || INVITE_USER_ERROR_MESSAGES.lastName}
                name="lastName"
                onChange={handleInputChange}
                onBlur={handleNameBlur}
              />
            </ModalInputContainer>
            <ModalInputContainer>
              <Input
                type="text"
                label={INVITE_USER_MODAL_CONSTANTS.LABEL_PHONE_NUMBER}
                value={getDisplayPhoneNumber(phoneNumber)}
                required={true}
                error={phoneTouched && invalidPhoneNum}
                errorText={INVITE_USER_ERROR_MESSAGES.phoneNumberGeneric}
                onChange={handlePhoneNumChange}
                helperTextPlacement="bottom"
              />
            </ModalInputContainer>
            <ModalInputContainer>
              <Input
                type="text"
                label={INVITE_USER_MODAL_CONSTANTS.LABEL_EMAIL}
                value={email}
                required={true}
                error={invalidEmail}
                errorText={errors["email"]}
                onChange={handleEmailChange}
              />
            </ModalInputContainer>
            <ModalButtonGroup>
              <Button
                size="medium"
                disabled={false}
                use="secondary"
                data-testid="inviteUserModal_stepOneCancelButton"
                onClick={handleBack}
              >
                {USER_GROUP_DETAILS_CONSTANTS.BUTTON_CANCEL}
              </Button>
              <Button
                size="medium"
                use="primary"
                data-testid="inviteUserModal_stepOneNextButton"
                onClick={handleNext}
                disabled={!isValid}
              >
                {INVITE_USER_MODAL_CONSTANTS.BUTTON_CONTINUE}
              </Button>
            </ModalButtonGroup>
          </>
        );
      case 2:
        return (
          <>
            <Title bold={true} size="medium">
              {INVITE_USER_MODAL_CONSTANTS.STEP_TWO_TITLE}
            </Title>
            <br />
            <br />
            <BillingAccountsListWrapper>
              <ListGroup
                topLine={false}
                bottomLine={false}
                surface="light"
                viewport="mobile"
              >
                {billingAccounts.map((ba) => {
                  const id = `ba-${ba}`; // unique id per checkbox
                  const checked =
                    selectedBillingAccounts.length > 0 &&
                    selectedBillingAccounts[0] === ba; // direct string match
                  return (
                    <BillingAccountRow
                      key={ba}
                      onClick={() => handleBillingAccountSelect(ba, !checked)}
                    >
                      <BillingAccountCheckboxWrapper>
                        <Checkbox
                          id={id}
                          selected={checked}
                          label ={""}
                          children ={ba}
                          onChange={(arg) => {
                            const nextChecked =
                              typeof arg === "boolean"
                                ? arg
                                : !!arg?.target?.checked;
                            handleBillingAccountSelect(ba, nextChecked);
                          }}
                          width="auto"
                        />

                      </BillingAccountCheckboxWrapper>
                      {/* <button
                        type="button"
                        onClick={(e) => {
                          e.stopPropagation();
                          onViewUsersOnAccount?.(ba);
                        }}
                        style={{
                          border: "none",
                          background: "transparent",
                          padding: 0,
                          margin: 0,
                          textDecoration: "underline",
                          fontSize: 14,
                          cursor: "pointer",
                        }}
                      >
                        View users on account
                      </button> */}
                    </BillingAccountRow>
                  );
                })}
              </ListGroup>
            </BillingAccountsListWrapper>
            <ModalButtonGroupWithMargin>
              <Button
                size="medium"
                disabled={false}
                use="secondary"
                data-testid="inviteUserModal_stepTwoBackButton"
                onClick={handleBack}
              >
                {USER_GROUP_DETAILS_CONSTANTS.BUTTON_BACK}
              </Button>
              <Button
                size="medium"
                use="primary"
                data-testid="inviteUserModal_stepTwoNextButton"
                onClick={handleNext}
                disabled={selectedBillingAccounts?.length === 0 || sitesFetchLoading}
              >
                {USER_GROUP_DETAILS_CONSTANTS.BUTTON_NEXT}
              </Button>
            </ModalButtonGroupWithMargin>
             {siteList.length === 0 && selectedBillingAccounts?.length > 0 && <Body size="medium" viewport="desktop" primitive="div" color="#C44904">
                {noSiteForBAIDMessage}
              </Body>}
            
          </>
        );
      case 3:
        return (
          <>
            <Title bold={true} size="medium">
              {INVITE_USER_MODAL_CONSTANTS.STEP_THREE_TITLE}
            </Title>
            <ModalDropdownContainer>
              {filteredSites === undefined || filteredSites?.length < 1 ? (
                <>
                  <ModalNotificationContainer>
                    <Notification
                      type="info"
                      priority="normal"
                      hideCloseButton={true}
                      title={INVITE_USER_MODAL_CONSTANTS.ROLE_ASSIGNMENT_NOTIFICATION_TITLE}
                      subtitle={INVITE_USER_MODAL_CONSTANTS.ROLE_ASSIGNMENT_NOTIFICATION_SUBTITLE}
                    />
                  </ModalNotificationContainer>
                  <DropdownSelect
                    label={INVITE_USER_MODAL_CONSTANTS.LABEL_ROLE}
                    errorText={INVITE_USER_MODAL_CONSTANTS.ERROR_TEXT_SELECT_ROLE}
                    error={false}
                    disabled={false}
                    readOnly={true}
                    name="role"
                    value={formValues?.role}
                    onChange={handleDropdownChange}
                  >
                    <option value={formValues?.role?.id}>{INVITE_USER_MODAL_CONSTANTS.OPTION_ADMIN}</option>
                  </DropdownSelect>
                </>
              ) : (
                <DropdownSelect
                  label={INVITE_USER_MODAL_CONSTANTS.LABEL_ROLE}
                  errorText={INVITE_USER_MODAL_CONSTANTS.ERROR_TEXT_SELECT_ROLE}
                  error={false}
                  disabled={false}
                  readOnly={false}
                  name="role"
                  value={formValues?.role}
                  onChange={handleDropdownChange}
                >
                  <option value="">{INVITE_USER_MODAL_CONSTANTS.ERROR_TEXT_SELECT_ROLE}</option>
                  {Array.isArray(rolesList) &&
                    rolesList
                      .filter(
                        (item) =>
                          item?.name?.toLowerCase() !== USER_ROLE.ADMIN ||
                          selectedRole?.toLowerCase() === USER_ROLE.ADMIN
                      )
                      .map((item) => (
                        <option value={item?.id}>{item?.name}</option>
                      ))}
                </DropdownSelect>
              )}
            </ModalDropdownContainer>

            <ModalButtonGroupWithTopMargin>
              <Button
                size="medium"
                disabled={loading}
                use="secondary"
                data-testid="inviteUserModal_stepThreeBackButton"
                onClick={handleBack}
              >
                {USER_GROUP_DETAILS_CONSTANTS.BUTTON_BACK}
              </Button>
              {filteredSites === undefined || filteredSites?.length < 1 ? (
                <Button
                  size="medium"
                  use="primary"
                  data-testid="inviteUserModal_stepThreeSubmitButton"
                  onClick={onSubmit}
                  disabled={loading}
                >
                  {INVITE_USER_MODAL_CONSTANTS.BUTTON_INVITE_USER}
                </Button>
              ) : (
                <Button
                  size="medium"
                  use="primary"
                  data-testid="inviteUserModal_stepThreeNextButton"
                  onClick={handleNext}
                  disabled={!formValues?.role || loading}
                >
                  {USER_GROUP_DETAILS_CONSTANTS.BUTTON_NEXT}
                </Button>
              )}
            </ModalButtonGroupWithTopMargin>
          </>
        );
      case 4:
        return (
          <>
            <AssignSiteStickyHeader>
              <Title bold={true} size="medium">
                {INVITE_USER_MODAL_CONSTANTS.STEP_FOUR_TITLE}
              </Title>
              <AssignSiteIntroWrapper>
                <Body size="medium">
                  {INVITE_USER_MODAL_CONSTANTS.STEP_FOUR_BODY}
                </Body>
              </AssignSiteIntroWrapper>
              <SiteSearchWrapper>
                <SearchInput
                  onChange={handleSearchChange}
                  placeholder={INVITE_USER_MODAL_CONSTANTS.SEARCH_SITES_PLACEHOLDER}
                />
              </SiteSearchWrapper>
            </AssignSiteStickyHeader>
            <SitesScrollWrapper>
              <div className="sitesGroup">
                <SiteRow
                  onClick={handleAllSitesToggle}
                  data-testid="inviteUserModal_stepFourAllSites-row"
                >
                  <Checkbox
                    selected={!!allSitesChecked}
                    onChange={(e) => {
                      // prevent row click double-invocation
                      e?.stopPropagation?.();
                      handleAllSitesToggle();
                    }}
                    disabled={roleName === INVITE_USER_MODAL_CONSTANTS.OPTION_ADMIN}
                    width="auto"
                  >
                    {INVITE_USER_MODAL_CONSTANTS.LABEL_ALL_SITES}
                  </Checkbox>
                </SiteRow>
                <ListGroup
                  topLine={false}
                  bottomLine={true}
                  surface="light"
                  viewport="mobile"
                >
                  <span>
                    {filteredSites?.map((site) => {
                      const siteKey = site.siteTagId || site.siteid || site.id;
                      return (
                        <SiteRow
                          onClick={() => handleSiteToggle(siteKey)}
                          data-testid={`inviteUserModal_stepFourSite-${siteKey}-row`}
                        >
                          <Checkbox
                            selected={!!site.checked}
                            onChange={() => handleSiteToggle(siteKey)}
                            disabled={roleName === INVITE_USER_MODAL_CONSTANTS.OPTION_ADMIN}
                            width="auto"
                          />
                          <SiteRowLabelWrapper>
                            <SiteRowName>
                              {site.name ||
                                site.title ||
                                site.siteTagName ||
                                INVITE_USER_MODAL_CONSTANTS.SITE_NAME_FALLBACK}
                            </SiteRowName>
                          </SiteRowLabelWrapper>
                        </SiteRow>
                      );
                    })}
                  </span>
                </ListGroup>
              </div>
            </SitesScrollWrapper>
            <AssignSiteStickyFooter>
              <ModalButtonGroupWithGap>
                <Button
                  size="medium"
                  disabled={loading}
                  use="secondary"
                  data-testid="inviteUserModal_stepFourBackButton"
                  onClick={handleBack}
                >
                  {USER_GROUP_DETAILS_CONSTANTS.BUTTON_BACK}
                </Button>
                <Button
                  size="medium"
                  use="primary"
                  data-testid="inviteUserModal_stepFourSendInviteButton"
                  onClick={onSubmit}
                  disabled={!isValid || loading}
                >
                  {INVITE_USER_MODAL_CONSTANTS.BUTTON_SEND_INVITE}
                </Button>
              </ModalButtonGroupWithGap>
            </AssignSiteStickyFooter>
          </>
        );
      default:
        return null;
    }
  };

  return (
    <div>
      <Modal
        opened={isModalOpen}
        onOpenedChange={(opened) => {
          if (!opened) {
            handleCloseModal();
          }
        }}
        ariaLabel={title}
        disableOutsideClick={true}
      >
        <div className="user-groups-modal">
          {renderStepContent()}
        </div>
      </Modal>
    </div>
  );
};

const mapStateToProps = (state) => ({
  firstName: state.inviteUserReducer.firstName,
  lastName: state.inviteUserReducer.lastName,
  phoneNumber: state.inviteUserReducer.phoneNumber,
  email: state.inviteUserReducer.email,
  checkedSites: state.inviteUserReducer.checkedSites,
  selectedGroups: state.inviteUserReducer.selectedGroups,
  billingAccounts: state.inviteUserModalReducer.billingAccounts,
});

const mapDispatchToProps = {
  setFirstName,
  setLastName,
  setPhoneNumber,
  setEmail,
  updateCheckedSites,
  updateSelectedGroups,
};
export default connect(mapStateToProps, mapDispatchToProps)(InviteUserModal);
